'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { FeatureTag } from '@/app/components/shared/FeatureTag';
import { cn } from '@/app/utils';

export interface ModelVersionSelectItemContentProps {
  image: string;
  title: string;
  description?: string;
  isNew?: boolean;
  activityTip?: ReactNode;
  className?: string;
}

export const ModelVersionSelectItemContent = ({
  image,
  title,
  description,
  isNew,
  activityTip,
  className,
}: ModelVersionSelectItemContentProps) => (
  <div className={cn('flex w-full items-center justify-start gap-2', className)}>
    <img src={image} alt={title} className="h-8 w-8 flex-shrink-0 rounded-4" />
    <div className="flex min-w-0 flex-col">
      <div className="flex min-w-0 items-center gap-1.5 whitespace-nowrap text-sm text-system-white">
        <span className="truncate">{title}</span>
        {isNew ? <FeatureTag /> : null}
        {activityTip}
      </div>
      {description ? <div className="truncate text-system-white40 text-xs">{description}</div> : null}
    </div>
  </div>
);

export const ModelVersionRemainingTrialsBadge = ({
  remainingTrials,
  className,
}: {
  remainingTrials: number;
  className?: string;
}) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        'ml-1 rounded-4 bg-[rgba(76,99,255,0.48)] p-1 text-[10px] text-system-white leading-[1]',
        className,
      )}
    >
      {t('create.createForm.settings.resolution.option1080p.remainingTrials', {
        count: remainingTrials,
        s: remainingTrials > 1 ? 's' : '',
        es: remainingTrials > 1 ? 'es' : '',
      })}
    </div>
  );
};
